/*
 * @Author: cryi.liu
 * @Date: 2020-05-11 16:03:25
 * @LastEditTime: 2020-07-15 14:38:25
 * @Description: api 列表
 */
export default {
  /**
   * 鉴权相关
   */
  auth: {
    login: '/mvc/mobile/api/login', // 本地环境登录接口
  },

  /**
   * 考试中心相关
   */
  examcenter: {
    libraryFilterMenu: '/examcentersite/library/menu',
    libraryFilterProductList: '/examcentersite/library/product',
    libraryList: '/examcentersite/library/list',
    libraryDeleteQuestion: '/examcentersite/library/delete/question',
    libraryExportQuestion: '/examcentersite/library/export',
    libraryWaitEditList: '/examcentersite/library/editList',
    libraryQuestionDetail: '/examcentersite/library/detail',
    librarySaveQuestion: '/examcentersite/library/save/question',
    libraryReScore: '/examcentersite/library/reScore',
    librarySaveStatus: '/examcentersite/library/saveStatus',
    libraryDeleteOption: '/examcentersite/library/delete/option',

    paperDetailInfo: '/examcentersite/paperDetail/userInfo',
    paperPersonList: '/examcentersite/paperDetail/page',
    paperDetailExport: '/examcentersite/paperDetail/export',
    paperDeleteByPerson: '/examcentersite/paperDetail/delete',
    paperDetailPersonInfo: '/examcentersite/answerDetail/userInfo',
    paperDetailAnswerDetail: '/examcentersite/answerDetail/detail',
    paperDetailUpdateShortScore: '/examcentersite/answerDetail/updateShort',

    paperCreateIndex: '/examcentersite/paper/index',
    paperCreateRequireQuestion: '/examcentersite/paper/import/excel',
    paperCreateSetScore: '/examcentersite/paper/rule/score',
    paperCreateDeleteBigQuestion: '/examcentersite/paper/rule',
    paperCreateAddBigQuestion: '/examcentersite/paper/rule',
    paperCreateProductList: '/examcentersite/paper/product/list',
    paperCreateProductCodes: '/examcentersite/paper/product/listBylibraryType',
    paperCreateQuestionCountByProductCodes: '/examcentersite/paper/product/libraryTypeCount',
    paperCreateQuestionCount: '/examcentersite/paper/library/statistic',
    paperCreateQuestionComplete: '/examcentersite/paper/rule/complete',
    paperCreateAddExamObject: '/examcentersite/paper/scope',
    paperCreateDeleteExamObjectByExcel: '/examcentersite/paper/upload/delete',
    paperCreateDonePaperSetting: '/examcentersite/paper/complete',

    approve: '/examcentersite/paper/exam/approve',
  },
  answer: {
    examQuestion: '/examcentersite/exam/question',
    saveAnswer: '/examcentersite/exam/saveAnswer',
    paper: '/examcentersite/exam/paper',
    submitPaper: '/examcentersite/exam/submitPaper',
    saveRemaining: '/examcentersite/exam/saveRemaining',
    markQuestionList: '/examcentersite/mark/question',
    markUserList: '/examcentersite/mark/answer',
    markSaveScore: '/examcentersite/mark/save/score',
  },
};
